module.exports = __webpack_public_path__ + "5c114213/img/share-action-icon.9c12578c.svg";